import { InsightCatalogue } from '../InsightCatalogue';
import {
  AggregateOnlyInsightPayload,
  InsightMetric,
  BaseInsightPayload,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface RequestsResponseRatioPayload
  extends AggregateOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_REQUESTS_RESPONSE_RATIO;
    id: string;
    attributes: {
      aggregate: {
        response_ratio: InsightMetric;
      };
    };
  };
}

export const parseRequestsResponseRatioPayload = (
  payload: BaseInsightPayload
): RequestsResponseRatioPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_REQUESTS_RESPONSE_RATIO,
    data.attributes,
    false,
    true,
    ['response_ratio']
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    aggregate: { response_ratio: InsightMetric };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_REQUESTS_RESPONSE_RATIO,
      id: data.id,
      attributes: {
        aggregate: {
          response_ratio: typedAttributes.aggregate.response_ratio,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
